
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsb236663201c9e10a3346551b6f6d193fen from './en.yaml'
            i18n.addResourceBundle('en', 'b236663201c9e10a3346551b6f6d193f', flattenObject(nsb236663201c9e10a3346551b6f6d193fen), true, true);
        
        export default 'b236663201c9e10a3346551b6f6d193f';
    